export default __webpack_public_path__ + "static/media/settings-grid-icon.6bd296a2.svg";